import { Identity } from '@core/redux/stores/identity.store';
import { LoyaltyMode } from './location.store';

export class User {
  // these are the basics user info attributes for both signed in and guest.
  // do not remove or change without knowing the ramifications of the change.
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phoneNumber: string | null;
  id?: string | null; // for a guest user may be a GUID past back from the server

  isGuest: boolean;

  // these attributes should apply to the signed in user only
  avatarId: number;
  dateOfBirth: Date;
  editablePropertyNames: string[];
  identities: Identity[];
  isEmailSubscriptionOn: boolean;
  isEmailVerified: boolean;
  isUsingTemporaryPassword: boolean;
  mainAccountType: string;
  idpSource?: string | null;
  missingProperties: string[];
  picture: string;
  profileEditingAllowed: boolean;
  profileImageType: string;
  stripeCustomerId: string;
  termsAcceptanceTime: Date;
  userType: number;
  isPushNotificationEnabled: boolean;
  zipCode: string;
  giftCardNumber: string;
  isAutoReloadConditionNotMet: boolean;
  beanstalkContactId: string;
  isSetupComplete: boolean;
  skipEmailValidation: boolean;
  isSafariPushDenied?: any;
  points?:number;
  loyaltyMode?: LoyaltyMode;
  constructor() {
    this.identities = new Array<Identity>();
  }
}
